import { createRoute } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";

const templatesManage = lazyWithRetry(
  () => import("./routes/templates/manage"),
);
const pushCampaigns = lazyWithRetry(() => import("./routes/push-campaigns"));

const templatesManageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/communication/templates/manage",
  component: () =>
    renderProtectedRoute(templatesManage, {
      requirePerms: ["marketing:read"],
    }),
});

const pushCampaignsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/communication/browser-notifications",
  component: () =>
    renderProtectedRoute(pushCampaigns, {
      requirePerms: ["marketing:read"],
    }),
});

export const communicationRouteTree = [
  templatesManageRoute,
  pushCampaignsRoute,
];
